"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusAccountPeriodDto = void 0;
class StatusAccountPeriodDto {
}
exports.StatusAccountPeriodDto = StatusAccountPeriodDto;
//# sourceMappingURL=status-account-period.dto.js.map